import React, { useState, useEffect, useLayoutEffect } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import { Collapse, Modal, Button, Space, Badge, Checkbox, List } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { reverse } from "named-urls";
import { sliceKey, reducer, actions } from "./slice";
import { bookingSaga } from "./saga";
import * as selectors from "./selectors";
import SelectBox from "../../../../components/SelectBox";
import TextArea from "../../../../components/TextArea";
import { useCart } from "../../../../contexts/cart";
import InputBox from "../../../../components/InputBox";
import routes from "../../../../../routes";
import PageHeader from "../../../../components/PageHeader";
import { useAuth } from "../../../../contexts/auth";
import * as roles from "../../../../constants/roles";
import "./style.css";
const { Panel } = Collapse;

/* const styles = {
  label: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.14",
    color: "rgba(144, 149, 173, 0.9)",
    marginBottom: "10px",
  },
}; */

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const BookingPage = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: bookingSaga });
  const dispatch = useDispatch();
  const cart = useCart();
  const history = useHistory();
  const location = useLocation();
  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;

  const [packageModalVisible, setPackageModalVisible] = useState(false);

  const handleCancel = () => {
    setPackageModalVisible(false);
  };

  const query = useQuery();
  const commodityId = query.get("commodityId");

  useEffect(() => {
    //dispatch(actions.fetchCompanyCatalog());
    dispatch(actions.fetchCommodities({ companyId: company._id }));
    dispatch(
      actions.fetchTests({
        companyId: company._id,
        commodityId: commodityId,
      })
    );
    return () => {
      dispatch(actions.initializeState());
    };
  }, [dispatch, commodityId, company]);

  //const allCategories = useSelector(selectors.selectTestCategories);

  const [selectedCommodity, setSelectedCommodity] = useState(commodityId);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [packageNotes, setPackageNotes] = useState("");
  const [packageName, setPackageName] = useState("");
  const [sampleCount, setSampleCount] = useState("");
  //const [categoryData, setCategoryData] = useState({});
  const commodityOptions = useSelector(selectors.selectCommodities);
  const tests = useSelector(selectors.selectTests);
  const [packageNameError, setPackageNameError] = useState(null);
  const [sampleCountError, setSampleCountError] = useState(null);
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  /*  useEffect(() => {
    const filteredCategoriesBySelectedCommodity = (selectedCommodityId) => {
      const catIds = Object.keys(allCategories);
      const toReturn = {};
      if (catIds?.length) {
        catIds.forEach((cat) => {
          const testsAvailable = allCategories[cat].tests || [];
          const eligibleTests = testsAvailable.filter(
            (entry) => entry.commodity._id === selectedCommodityId
          );
          if (eligibleTests.length) {
            toReturn[cat] = allCategories[cat];
            toReturn[cat].tests = eligibleTests;
          }
        });
        return toReturn;
      } else {
        return {};
      }
    };
    const cats = filteredCategoriesBySelectedCommodity(selectedCommodity);
    console.log(cats);
    setCategoryData(cats);
  }, [selectedCommodity, allCategories]); */

  const dataForTests = tests.reduce((acc, obj) => {
    let key = obj.value;
    const tests = obj.options.map((test) => {
      return {
        ...test,
        testCategory: key,
      };
    });
    let testCategoryObj = {
      ...obj,
      options: tests,
    };
    if (!acc[key]) acc[key] = testCategoryObj;
    return acc;
  }, {});

  const handleCommoditySelect = (selected) => {
    setSelectedCommodity(selected);
    setSelectedParameters([]);
    const params = new URLSearchParams({ commodityId: selected });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const handleTestCategoriesSelect = (data) => {
    let count = 0;
    selectedParameters.forEach((parameter) => {
      if (data.value === parameter.testCategory) count++;
    });

    const parameters = [...selectedParameters];

    const finalParametersArray = [];

    parameters.forEach((parameter) => {
      if (data.value !== parameter.testCategory)
        finalParametersArray.push(parameter);
    });
    if (count !== data.options.length)
      finalParametersArray.push(...data.options);

    setSelectedParameters(finalParametersArray);
  };

  const handleParameterSelect = (data) => {
    const currentSelected = [...selectedParameters];
    const index = currentSelected.findIndex((row) => row.value === data.value);
    if (index === -1) {
      currentSelected.push(data);
    } else {
      currentSelected.splice(index, 1);
    }
    setSelectedParameters(currentSelected);
  };

  const getSelectedTestsCount = (testCategory) => {
    const selectedTests = [...selectedParameters];

    return selectedTests.filter((test) => test.testCategory === testCategory)
      .length;
  };

  const handleAddToCart = () => {
    if (packageName.match(/^(?!\s+$).+/) === null)
      setPackageNameError("Please provide a valid name for Package");
    else if (sampleCount < 1) setSampleCountError("Please provide a number");
    else {
      setPackageModalVisible(false);
      const parameters = [...selectedParameters];
      const lineItems = [];
      parameters.forEach((param) => {
        lineItems.push(param.value);
      });

      const cartPackage = {
        notes: packageNotes,
        package: {
          name: packageName,
          tests: [...lineItems],
        },
        sampleCount: sampleCount,
      };

      cart.addToCart(cartPackage, () => history.push(reverse(routes.cart)));
    }
  };

  const handlePackageModal = () => {
    setPackageNotes("");
    setPackageName("");
    setSampleCount("");
    setSampleCountError(null);
    setPackageNameError(null);
    setPackageModalVisible(true);
  };

  const evaluateCheckedForTest = (test) => {
    let check = false;
    selectedParameters.forEach((parameter) => {
      if (parameter.value === test.value) check = true;
    });
    return check;
  };

  const evaluateCheckedForTestCategory = (testCategory) => {
    let count = 0;
    selectedParameters.forEach((parameter) => {
      if (parameter.testCategory === testCategory.value) {
        count = count + 1;
      }
    });
    if (count === testCategory.options.length) return true;
    else return false;
  };
  const renderTestCategories = (entries) => {
    const rows = [];
    Object.keys(entries).forEach((key, index) => {
      const entry = entries[key];
      const tests = entry.options || {};
      const selected = getSelectedTestsCount(entry.value);
      if (tests.length) {
        rows.push(
          <Panel
            header={
              <span>
                <Checkbox
                  key={entry.value}
                  onChange={() => {
                    handleTestCategoriesSelect(entry);
                  }}
                  checked={evaluateCheckedForTestCategory(entry)}
                >
                  {" "}
                </Checkbox>
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#0a8080",
                    marginLeft: "5px",
                  }}
                  id="testCategory"
                >
                  {entry.label}{" "}
                  {selected > 0
                    ? `(${selected}/${tests.length} test${
                        selected > 1 ? "s" : ""
                      } selected)`
                    : `(${tests.length} test${tests.length > 1 ? "s" : ""})`}
                </span>
              </span>
            }
            key={index}
            style={{
              marginBottom: 20,
              overflow: "hidden",
              backgroundColor: "#eff3f7",
              border: "0px",
              borderRadius: 4,
              color: "#0a8080",
            }}
          >
            <div style={{ marginLeft: "20px" }}>
              <List
                itemLayout="horizontal"
                dataSource={tests}
                renderItem={(test) => (
                  <List.Item>
                    <List.Item.Meta
                      title={
                        <Checkbox
                          key={test.value}
                          onChange={() => {
                            handleParameterSelect(test);
                          }}
                          checked={evaluateCheckedForTest(test)}
                        >
                          <span className="test">{test.parameter}</span>
                        </Checkbox>
                      }
                    />
                    {currentUser.role === roles.COMPANY_ADMIN.name ||
                    priceVisible ? (
                      <div className="test"> ₹ {test.price}</div>
                    ) : (
                      ""
                    )}
                  </List.Item>
                )}
              />
            </div>
          </Panel>
        );
      }
    });
    return rows;
  };

  const getSelectedValue = (categories, selectedId) => {
    let value;
    categories.forEach((cat) => {
      const selected = cat.options.filter((opt) => opt.value === selectedId);
      if (selected.length) value = selected[0];
    });
    return value;
  };

  const handleSampleCountChange = (val) => {
    if (val > 100) {
      return null;
    } else if (val > 0) {
      setSampleCount(val);
    } else {
      setSampleCount(0);
    }
  };

  useLayoutEffect(() => {
    function updateWindowSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener("resize", updateWindowSize);
    updateWindowSize();
    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);
  return (
    <div>
      <PageHeader
        title="Order Booking"
        actions={
          <Space>
            <Link to={routes.placeOrder}>
              <Button
                size={
                  windowSize > 600
                    ? "large"
                    : windowSize > 500
                    ? "middle"
                    : "small"
                }
                style={{ borderRadius: 4 }}
              >
                Cancel
              </Button>
            </Link>
            <Button
              type="primary"
              size={
                windowSize > 600
                  ? "large"
                  : windowSize > 500
                  ? "middle"
                  : "small"
              }
              disabled={!selectedParameters.length}
              onClick={handlePackageModal}
            >
              <span className="cartLabel">
                Add to Cart{" "}
                <Badge
                  offset={[7, -2]}
                  count={
                    selectedParameters.length
                      ? `(${selectedParameters.length} Test${
                          selectedParameters.length > 1 ? "s" : ""
                        })`
                      : 0
                  }
                />
              </span>
            </Button>
          </Space>
        }
      />
      <div>
        <div>
          <p className="label">Commodity</p>
          <SelectBox
            noMargin
            options={commodityOptions}
            placeholder="Start typing or select from options..."
            value={getSelectedValue(commodityOptions, selectedCommodity)}
            onChange={(selected) => handleCommoditySelect(selected)}
          />
        </div>
      </div>
      <div style={{ marginTop: 30 }}>
        <p className="label">Tests</p>
        <Collapse
          bordered={false}
          expandIconPosition="right"
          expandIcon={({ isActive }) => (
            <CaretRightOutlined
              style={{ color: "#0a8080" }}
              rotate={isActive ? 90 : 0}
            />
          )}
          style={{ background: "#fff" }}
        >
          {renderTestCategories(dataForTests)}
        </Collapse>
      </div>
      <Modal
        title="Create Package"
        visible={packageModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <InputBox
          placeholder="Enter a package name"
          value={packageName}
          onChange={(e) => setPackageName(e.target.value)}
          label="Package name"
        />
        {packageNameError && <p style={{ color: "red" }}>{packageNameError}</p>}
        <InputBox
          placeholder="Enter number of samples to be picked"
          value={sampleCount}
          onChange={(e) => handleSampleCountChange(e.target.value)}
          label="Sample Count"
          type="number"
          min={0}
          max={100}
        />
        {sampleCountError && <p style={{ color: "red" }}>{sampleCountError}</p>}
        <TextArea
          placeholder="Add any relevant instructions"
          value={packageNotes}
          onChange={(e) => setPackageNotes(e.target.value)}
          label="Notes/Instructions"
        />
        <div
          style={{ display: "flex", marginTop: 20, justifyContent: "flex-end" }}
        >
          <Button onClick={handleCancel} style={{ marginRight: 20 }}>
            Cancel
          </Button>
          <Button
            disabled={!packageName || packageName === "" || !sampleCount}
            onClick={handleAddToCart}
            type="primary"
          >
            Add to Cart
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default BookingPage;
